import { reactive } from "@vue/runtime-core";

type Viewport = {
  windowWidth: number
  windowHeight: number
  isMobile: boolean
  isTablet: boolean
  isDesktop: boolean
  isLandscape: boolean
  isTouch: boolean
}

const Viewport = reactive<Viewport>({
  windowWidth: window.innerWidth,
  windowHeight: window.innerHeight,
  isMobile: false,
  isTablet: false,
  isDesktop: false,
  isLandscape: false,
  isTouch: "ontouchstart" in window
}) as Viewport
export default Viewport


Viewport.isMobile = isMobile();
Viewport.isTablet = isTablet();
Viewport.isDesktop = isDesktop();
Viewport.isLandscape = isLandscape();
Viewport.isTouch = isTouch();

function isMobile(){
  return Viewport.windowWidth < 550;
}

function isTablet(){
  return Viewport.windowWidth >= 550 && Viewport.windowWidth < 1050;
}

function isDesktop(){
  return Viewport.windowWidth >= 1050;
}

function isLandscape(){
  return Viewport.windowWidth > Viewport.windowHeight
}

function isTouch(){
  return "ontouchstart" in window
}

function onResize(){
  Viewport.windowWidth = window.innerWidth
  Viewport.windowHeight = window.innerHeight
  Viewport.isMobile = isMobile()
  Viewport.isTablet = isTablet()
  Viewport.isDesktop = isDesktop()
  Viewport.isLandscape = isLandscape()

  calculateVH()
}

const calculateVH = () => {
  document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
}


export function disposeViewport(): void {
  window.removeEventListener('resize', onResize);
}

window.addEventListener('resize', onResize);
calculateVH()